/** Browser session presence + resource heartbeat for admin monitor */
function authHeaders(): HeadersInit {
  const t = localStorage.getItem("arclog.token");
  return t
    ? { Authorization: "Bearer " + t, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

function sessionKey(): string {
  const k = "arclog.presence.sessionKey";
  let v = sessionStorage.getItem(k);
  if (!v) {
    v = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(k, v);
  }
  return v;
}

function heap() {
  try {
    const m = (performance as unknown as { memory?: { usedJSHeapSize: number; totalJSHeapSize: number; jsHeapSizeLimit: number } }).memory;
    if (!m) return {};
    return {
      jsHeapUsed: m.usedJSHeapSize,
      jsHeapTotal: m.totalJSHeapSize,
      jsHeapLimit: m.jsHeapSizeLimit,
    };
  } catch {
    return {};
  }
}

export function startPresenceHeartbeat(getSnapshot: () => {
  windowCount: number;
  fps?: number;
  longTasks?: number;
  openApps: string[];
  user?: { id?: string; username?: string; role?: string } | null;
}) {
  const key = sessionKey();
  let timer: number | null = null;
  let alive = true;

  const beat = async () => {
    if (!alive || !localStorage.getItem("arclog.token")) return;
    try {
      const snap = getSnapshot();
      const userRaw = localStorage.getItem("arclog.user");
      let user: { id?: string; username?: string; role?: string } | null = snap.user || null;
      if (!user && userRaw) {
        try {
          user = JSON.parse(userRaw);
        } catch {
          user = null;
        }
      }
      await fetch("/api/system/presence/heartbeat", {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          sessionKey: key,
          ...heap(),
          windowCount: snap.windowCount,
          fps: snap.fps,
          longTasks: snap.longTasks,
          openApps: snap.openApps,
          userAgent: navigator.userAgent,
        }),
      });
    } catch {
      /* offline ok */
    }
  };

  void beat();
  timer = window.setInterval(() => void beat(), 12_000);

  const onHide = () => {
    if (document.visibilityState === "visible") void beat();
  };
  document.addEventListener("visibilitychange", onHide);

  const leave = () => {
    try {
      const body = JSON.stringify({ sessionKey: key });
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: "application/json" });
        navigator.sendBeacon("/api/system/presence/leave", blob);
      }
    } catch {
      /* */
    }
  };
  window.addEventListener("pagehide", leave);

  return () => {
    alive = false;
    if (timer) clearInterval(timer);
    document.removeEventListener("visibilitychange", onHide);
    window.removeEventListener("pagehide", leave);
    leave();
  };
}
